import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 ,  error: "", message: "" }


export const getAllChallengeAction = createAsyncThunk(
    'get-all-challenge',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/allChallenge?is_active=${data?.is_active}&is_mission=${data?.is_mission}&page=${data?.page}&limit=${data?.limit}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getChallengeSlice = createSlice({
    name: 'get-all-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllChallengeAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllChallengeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.count
            })
            builder.addCase(getAllChallengeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getChallengeReducer = getChallengeSlice.reducer    